const imageWithTextColumnsSwipers = document.querySelectorAll(
  ".image-with-text-columns .swiper"
);

imageWithTextColumnsSwipers.forEach((slider) => {
  new Swiper(slider, {
    speed: 600,
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1: {
        slidesPerView: 1.12,
        spaceBetween: 16,
      },
    },
  });
});

var videosSwiper = new Swiper(".videos-swiper", {
  slidesPerView: 4,
  spaceBetween: 80,
  speed: 550,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    1390: {
      slidesPerView: 4,
      spaceBetween: 80,
    },
    968: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    680: {
      slidesPerView: 2.5,
      spaceBetween: 12,
    },
    0: {
      slidesPerView: 1.5,
      spaceBetween: 12,
    }
  },
});
const videosSwiperElement = document.querySelector(".videos-swiper");
const videosSlides = document.querySelectorAll(".videos-swiper .swiper-slide");
if (videosSlides.length < 5 && videosSwiperElement) videosSwiperElement.classList.add("hide-buttons");

const logoListSwipers = document.querySelectorAll(".logo-list-swiper.swiper");
logoListSwipers.forEach((slider) => {
  const speed = parseFloat(slider.dataset.speed) * 1000;

  const logoListSwiper = new Swiper(slider, {
    speed: speed,
    loop: true,
    allowTouchMove: false,
    disableOnInteraction: false,
    autoplay: {
      delay: 1,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 5,
      },
      550: {
        slidesPerView: 3,
      },
      1: {
        slidesPerView: 2,
      },
    },
  });
});

const logoListSwipersV2 = document.querySelectorAll(
  ".logo-list-swiper-v2.swiper"
);
logoListSwipersV2.forEach((slider) => {
  const speed = parseFloat(slider.dataset.speed) * 1000;

  const logoListSwiper = new Swiper(slider, {
    speed: speed,
    loop: true,
    allowTouchMove: false,
    disableOnInteraction: false,
    autoplay: {
      delay: 1,
    },
    breakpoints: {
      1750: {
        slidesPerView: 5,
        spaceBetween: 5,
      },
      1330: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      660: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1: {
        slidesPerView: 1.65,
        spaceBetween: 20,
      },
    },
  });
});
